import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Layout from "@common/layout/Layout";
import usePackagesCrud from "../hooks/usePackagesCrud";
import useContextUrl from "@common/hooks/useContextUrl";
import useNavigationUrl from "@common/hooks/useNavigationUrl";
import { PackageCrudResult } from "@models/ISchema";
import { DataReducerType } from "../context/types";
import { ContextEDH } from "@context/ContextEDH";
import {
  PackageCreationHeader,
  PackageCreationWizard,
  PackageWithLeaguesStoreProvider,
} from "../package-with-leagues-creation";

const PackageCreation = () => {
  // Hooks for hanlde the history and the context
  const history = useHistory();
  const { state } = useContext(ContextEDH);
  const { origin, scenario } = useContextUrl();
  const { editorUrl, adaptedHomeUrl } = useNavigationUrl();
  const [resultPackagesCrud, submitPackagesCrud] = usePackagesCrud({ scenario, origin });
  const userCanEditPackages = state?.base?.base?.user?.abilities?.can_edit_packages;

  const onPackageCrudSubmit = async (data: DataReducerType) => {
    if (resultPackagesCrud.isLoading) return;
    await submitPackagesCrud(data, { dryRun: false, skipValidations: true });
  };

  useEffect(() => {
    if (!!state?.base?.base?.user?.abilities && !userCanEditPackages) {
      history.goBack();
    }
  }, [userCanEditPackages]);

  useEffect(() => {
    const result = resultPackagesCrud?.result as PackageCrudResult;

    if (result?.payload?.creates?.length) {
      const createdPackage = result?.payload?.creates[0]?.package;
      history.push(editorUrl("package", createdPackage?.id));
    }
  }, [resultPackagesCrud?.result]);

  return (
    <Layout contextSearch>
      <PackageWithLeaguesStoreProvider>
        <PackageCreationHeader homePath={adaptedHomeUrl()} />

        <PackageCreationWizard
          onPackageOnlySubmit={onPackageCrudSubmit}
          isPackageOnlyLoading={resultPackagesCrud?.isLoading}
          onCancel={history.goBack}
        />
      </PackageWithLeaguesStoreProvider>
    </Layout>
  );
};

export default PackageCreation;
